/**
 * Historical Significance Components
 * Exports all historical significance related components
 */

export { HistoricalSignificanceSection } from './HistoricalSignificanceSection';
export { HistoricalSignificanceList } from './HistoricalSignificanceList';
export { HistoricalSignificanceItem } from './HistoricalSignificanceItem';

// Export types
export type {
  HistoricalSignificanceSectionProps,
  HistoricalSignificanceItemData,
} from './types';
export type { HistoricalSignificanceListProps } from './HistoricalSignificanceList';
export type { HistoricalSignificanceItemProps } from './HistoricalSignificanceItem';
